import React from 'react';
import Form from 'react-jsonschema-form';
import HasOneWidget from './formLib/HasOneWidget';
import WysiwygWidget from './formLib/WysiwygWidget';
import HasManyField from './formLib/HasManyField';
import FieldTemplate from './formLib/FieldTemplate';
import SelectOneWidget from './formLib/SelectOneWidget';
// NOTE: TitleField is used for ArrayField
import TitleField from './formLib/TitleField';
import CurrencyWidget from './formLib/CurrencyWidget';
import SectionWidget from './formLib/SectionWidget';
import NumberWidget from './formLib/NumberWidget';
import extendFormData from '../formLib/extendFormData';
import SlugWidget from './formLib/SlugWidget';

function FormButtons(props) {
  const {
    onCancel,
    onPublish,
    onChange,
    onDuplicate,
    onCreateTemplate,
    onUseTemplate,
    isDuplicable,
    isPublished,
    isPublishable,
    readOnly,
    openPlatform,
  } = props;

  if (readOnly) {
    return (
      <div className="form__button-toolbar">
        <button type="submit" className="btn form__btn-save" style={{ display: 'none' }}>
          Save
        </button>
        {onUseTemplate && (
          <button type="button" onClick={onUseTemplate} className="btn form__btn-duplicate">
            Use this Template
          </button>
        )}
        <button type="button" className="btn form__btn-cancel" onClick={onCancel}>
          Back
        </button>
      </div>
    );
  }

  return (
    <div className="form__button-toolbar">
      {!openPlatform &&
      <div>
        <button type="submit" className="btn form__btn-save">
          Save
        </button>
        {isPublishable &&
          !readOnly &&
          (isPublished ? (
            <button type="button" onClick={onPublish} className="btn form__btn-unpublish">
              Unpublish
            </button>
          ) : (
            <button
              type="submit"
              onClick={() => {
                if (onChange) {
                  onChange({ formData: { published: true } });
                }
              }}
              className="btn form__btn-publish"
            >
              Save & Publish
            </button>
          ))}
        {isDuplicable && (
          <button type="button" onClick={onDuplicate} className="btn form__btn-duplicate">
            Duplicate
          </button>
        )}
        {onCreateTemplate && (
          <button type="button" onClick={onCreateTemplate} className="btn form__btn-duplicate">
            Use as Template
          </button>
        )}
      </div>}
      <button type="button" className="btn form__btn-cancel" onClick={onCancel}>
        {openPlatform ? 'Back' : 'Cancel'}
      </button>
    </div>
  );
}

const defaultWidgets = {
  currencyWidget: CurrencyWidget,
  hasOneWidget: HasOneWidget,
  numberWidget: NumberWidget,
  wysiwygWidget: WysiwygWidget,
  sectionWidget: SectionWidget,
  slugWidget: SlugWidget,
  selectOneWidget: SelectOneWidget,
};

const defaultFields = {
  hasManyField: HasManyField,
  TitleField,
};

function ExtendedForm(props) {
  const jsonSchemaFormExtensions = props.jsonSchemaFormExtensions || {};
  const { widgets = {}, fields = {} } = jsonSchemaFormExtensions;
  props = extendFormData(props);
  return (
    <Form
      FieldTemplate={FieldTemplate}
      widgets={{ ...defaultWidgets, ...widgets }}
      fields={{ ...defaultFields, ...fields }}
      onSubmit={(sub) => {
        // NOTE: this is "hacky" solution to allow for validation to happen on top
        // of publishing and saving
        setTimeout(props.onSubmit(sub), 200);
      }}
      {...props}
    >
      <FormButtons
        onCancel={props.onCancel}
        readOnly={props.readOnly}
        onPublish={props.onPublish}
        onChange={props.onChange}
        onDuplicate={props.onDuplicate}
        onCreateTemplate={props.onCreateTemplate}
        onUseTemplate={props.onUseTemplate}
        isPublished={props.isPublished}
        isPublishable={props.isPublishable}
        isDuplicable={props.isDuplicable}
        openPlatform={props.openPlatform}
      />
    </Form>
  );
}

export default ExtendedForm;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/Form.js